<template>
  <div id="tabTeams">
    <div class="margin-subpages">
      <div>
        <div class="flex-row-center">
          <div class="flex-center-1 fs-24 f-000000">
            <span class="fw-900">{{
              teamsall.length > 0
                ? $utils("addCommasInNumber", teamsall.length)
                : 0
            }}</span>
            <span class="fw-600">&nbsp;{{ $t("members.Teams") }}</span>
            <span v-if="teamDuplicate.status" class="txtIncomplete"
              >{{ teamDuplicate.count }}
              {{ $t("members.duplicate_teams") }}</span
            >
          </div>
          <el-button
            @click="addTeam"
            class="btnAddTeam"
            size="small"
            icon="el-icon-plus"
            >{{ $t("members.ADD_TEAM") }}</el-button
          >
        </div>
        <div class="flex-row-between mt-24">
          <el-input
            class="input-style"
            style="font-size: 14px; height: 40px"
            autosize
            :placeholder="$t('members.Search')"
            v-model="inputSearch"
            clearable
          ></el-input>
          <div style="width: 220px">
            <el-menu class="el-menu-demo menuOptionStyle" mode="horizontal">
              <el-submenu index="0" style="width: 220px">
                <template slot="title">
                  <span class="txtOption" id="sortby">{{
                    $t("members.Sort_by_Name")
                  }}</span>
                </template>
                <el-menu-item
                  index="1"
                  @click="sortBy('name')"
                  style="font-size: 14px; width: 220px"
                  >{{ $t("members.Sort_by_Name") }}</el-menu-item
                >
                <el-menu-item
                  index="2"
                  @click="sortBy('parent')"
                  style="font-size: 14px; width: 220px"
                  >{{ $t("members.Sort_by_Parent") }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div>
        </div>
        <div class="mt-24">
          <div class="opa-04" v-if="loadingTeamsTable">
            <div
              v-for="item in [1, 2, 3, 4]"
              :key="'mock_team_' + item"
              :class="{
                'opa-02': item == 4,
                'opa-04': item == 3,
                'opa-06': item == 2,
              }"
              class="grid-4"
            >
              <div
                class="team-sitebar"
                style="background: #747474; opacity: 0.4"
              ></div>
              <div class="px-24 flex-center">
                <div class="fw-700 fs-17 text-skeleton" style="width: 90px">
                  &nbsp;
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-row-center">
                  <div class="image-skeleton image-profile-42 opa-06"></div>
                  <div class="flex-column" style="padding-left: 8px">
                    <div class="fw-700 fs-12 text-skeleton" style="width: 80px">
                      &nbsp;
                    </div>
                    <div
                      class="fw-700 fs-12 text-skeleton opa-06 mt-4"
                      style="width: 90px"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-10 text-skeleton opa-04"
                    style="width: 50px"
                  >
                    &nbsp;
                  </div>
                  <div class="flex-row-center mt-4">
                    <div class="opa-04" style="display: flex">
                      <div
                        v-for="index in [1, 2, 3, 4]"
                        :key="index + '_mock_user'"
                      >
                        <div v-if="index < 7">
                          <div>
                            <div
                              class="image-skeleton image-profile-32"
                              :style="renderMemberPic(index)"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-12 text-skeleton opa-05"
                    style="width: 80px"
                  >
                    &nbsp;
                  </div>
                  <div
                    class="fw-700 fs-15 text-skeleton mt-4"
                    style="width: 120px"
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="item in teams"
            :key="item.key"
            :class="{ duplicateStyle: item.duplicate }"
            class="grid-4 cursor-pointer"
            @click="editTeam(item)"
          >
            <div
              class="team-sitebar"
              v-bind:style="teamBarStyleFunc(item.color)"
            ></div>
            <div class="px-24 flex-center">
              <span class="fw-700 fs-17 fc-000000 ellipsis"
              :class="[ blurMode ?  'blurelement': '' ]">{{
                item.name
              }}</span>
            </div>
            <div class="px-24 flex-center">
              <div v-if="item.multiple == true" class="flex-row-center">
                <div>
                  <img
                    :src="$utils('icons', 'ic_multiple_managers')"
                    alt="icons_ic_multiple_managers"
                    class="image-skeleton image-profile-42"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div class="flex-column" style="padding-left: 8px">
                  <span class="text-name">{{"Multiple Managers"}}</span>
                  <span class="text-email">{{
                    $t("members.Team_Manager")
                  }}</span>
                </div>
              </div>
              <div v-else class="flex-row-center">
                <div v-if="item.pic">
                  <img
                    v-lazy="item.pic"
                    :key="item.pic"
                    class="image-skeleton image-profile-42"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div v-else class="image image-profile-42"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="flex-mid text-in-image text-in-image-42">
                    {{
                      $utils("acronymName", {
                        firstName: item.boss_firstname,
                        lastName: item.boss_lastname,
                      })
                    }}
                  </div>
                </div>
                <div class="flex-column" style="padding-left: 8px">
                  <span class="text-name"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    item.boss_firstname
                      ? item.boss_firstname + " " + item.boss_lastname.charAt(0)
                      : "Unassigned"
                  }}</span>
                  <span class="text-email"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    $t("members.Team_Manager")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="px-24 flex-center">
              <div class="flex-column">
                <span class="fc-4A4A4A fs-12"
                  >{{ item.sup ? item.sup.length : 0 }}
                  {{ $t("members.Members") }}</span
                >
                <div class="flex-row-center mt-2">
                  <div v-if="item.sup" style="display: flex">
                    <div v-for="(manager, index) in item.sup" :key="index">
                      <div v-if="index < 7">
                        <div v-if="manager.pic">
                          <img
                            v-lazy="manager.pic"
                            :key="manager.pic"
                            class="image-skeleton image-profile-32"
                            :class="[ blurMode ?  'blurelement': '' ]"
                            :style="renderMemberPic(index)"
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32"
                          :class="[ blurMode ?  'blurelement': '' ]"
                          :style="renderMemberPic(index)"
                        >
                          <div class="text-in-image text-in-image-42 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: manager.firstname,
                                lastName: manager.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="index == 7"
                        class="image image-profile-32"
                        :style="renderMemberPic(index)"
                      >
                        <div
                          class="text-in-image text-in-image-42 flex-mid"
                          :style="`font-weight: 700; font-size: ${
                            item.sup.length < 99
                              ? '15'
                              : item.sup.length < 999
                              ? '12'
                              : '9'
                          }px;`"
                        >
                          {{
                            item.sup.length > 7
                              ? "+" + (item.sup.length - 7)
                              : ""
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <span
                    class="fw-700 fs-14 fc-4A4A4A"
                    style="margin-left: -53px;"
                  >{{ (item.sup && item.sup.length > 7) ? "+"+(item.sup.length - 7) : "" }}</span> -->
                </div>
              </div>
            </div>
            <div class="px-24 flex-center">
              <div class="flex-column">
                <span class="fc-4A4A4A fs-12">{{
                  $t("members.Parent_Team")
                }}</span>
                <span v-if="item.parent_name" class="fs-16 fw-700 fc-4A4A4A"
                :class="[ blurMode ?  'blurelement': '' ]">{{
                  item.parent_name
                }}</span>
                <span v-else
                :class="[ blurMode ?  'blurelement': '' ]">&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20 pagination flex-center" v-if="!loadingTeamsTable">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="results"
        ></el-pagination>
        <span class="results-status">
          {{ results > 10 ? 10 : results }} {{ $t("members.results_from") }}
          {{ $utils("addCommasInNumber", results) }} {{ $t("members.results") }}
        </span>
      </div>
    </div>

    <el-dialog :visible.sync="dialogFormVisible" top="8vh">
      <div
        class="sidebar-modal-color"
        v-bind:class="renderSidebarColorFunc(modalForm.color)"
      ></div>
      <el-form :model="modalForm" ref="modalForm">
        <el-col :span="11" class="first-column profileform">
          <div
            style="padding-top: 60px; padding-left: 40px; padding-right: 40px"
          >
            <el-col :span="24">
              <p class="txtHeaderStyle">{{ $t("members.Team_Name") }}</p>
              <el-input
                class="team-field"
                auto-complete="off"
                :placeholder="$t('members.Team_Name')"
                v-model="modalForm.team_name"
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-input>
            </el-col>
            <el-col :span="24" style="padding-top: 24px">
              <p class="txtHeaderStyle">{{ $t("members.Parent_Team") }}</p>
              <el-autocomplete
                class="inline-input team-parent-field"
                v-bind:class="
                  renderParentSidebarColorFunc(modalForm.parent_color)
                "
                v-model="modalForm.dispteam_parent"
                :fetch-suggestions="querySearchTeam"
                :placeholder="$t('members.Auto_assignment')"
                @select="handleSelectTeam"
                style="width: 100%"
                :disabled="true"
                :class="[ blurMode ?  'blurelement': '' ]"
              >
                <template slot-scope="{ item }">
                  <div class="item">{{ item.name }}</div>
                </template>
              </el-autocomplete>
            </el-col>
            <el-col :span="24" style="padding-top: 24px">
              <p class="txtHeaderStyle">{{ $t("members.Managers") }}</p>
              <div v-if="modalForm.multiple == true" class="flex-row-center" style="padding-top: 8px">
                <div>
                  <img
                    :src="$utils('icons', 'ic_multiple_managers')"
                    alt="icons_ic_multiple_managers"
                    class="image-skeleton image-profile-52"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    padding-left: 16px;
                  "
                >
                  <span class="fs-18 fc-000000">{{"Multiple Managers"}}</span>
                </div>
              </div>
              <div v-else class="flex-row-center" style="padding-top: 8px">
                <div v-if="modalForm.parent_pic">
                  <img
                    v-lazy="modalForm.parent_pic"
                    :key="modalForm.parent_pic"
                    class="image-skeleton image-profile-52"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div v-else class="image image-profile-52"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-52 flex-mid">
                    {{
                      $utils("acronymName", { fullName: modalForm.boss_name })
                    }}
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    padding-left: 16px;
                  "
                >
                  <span class="fs-18 fc-000000"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    modalForm.boss_name
                      ? modalForm.boss_name
                      : "Auto-assignment"
                  }}</span>
                </div>
              </div>
            </el-col>
            <el-col :span="24" style="padding-top: 38px">
              <p class="txtHeaderStyle">{{ $t("members.Color_Tag") }}</p>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  position: absolute;
                "
              >
                <div
                  v-for="(color, index) in tagColorMaster"
                  :key="index"
                  class="tagColor"
                  @click="tagColorCheckFunc(index, color)"
                  v-bind:class="[
                    {
                      'active-check':
                        modalForm.selectedColorForUpdate === index,
                    },
                    `bg-${color}`,
                  ]"
                ></div>
              </div>
            </el-col>
            <el-col
              :span="24"
              style="padding-top: 90px; display: flex; align-items: center"
            >
              <el-button class="btnAddTeamModal" @click="saveTeam">{{
                modalForm.mode
                  ? $t("members.SAVE_CHANGES")
                  : $t("members.CREATE_TEAM")
              }}</el-button>
              <el-button
                v-if="modalForm.mode"
                :disabled="modalForm.sup.length > 0 || modalForm.checkparent"
                class="btnCancelTeamModal btn-gray"
                type="primary"
                @click="deleteTeam"
                >{{ $t("members.DELETE") }}</el-button
              >
              <el-button
                v-else
                class="btnCancelTeamModal btn-gray"
                type="primary"
                @click="dialogFormVisible = false"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </el-col>
            <el-col :span="24" style="padding-top: 170px">
              <div class="flex-center">
                <p class="txtHeaderStyle">Internal Value</p>
                <el-tooltip placement="top">
                  <div slot="content">
                    <div class="flex-mid ml-auto fs-11" style="width: 210px">
                      This unique identifier will be used when syncing with
                      integration partners. Once created it can’t be edited.
                    </div>
                  </div>
                  <img
                    :src="$utils('icons', 'ic_help_outline-16px')"
                    alt="icons_ic_help_outline-16px"
                    class="ml-12 pb-8"
                  />
                </el-tooltip>
              </div>
              <div
                @click="copyURL(modalForm.internal_id)"
                class="style-internal-value flex-center"
              >
                {{ modalForm.internal_id }}
              </div>
            </el-col>
          </div>
        </el-col>
        <el-col :span="13" class="second-column">
          <div v-if="!modalForm.mode" class="px-40" style="padding-top: 60px">
            <el-col :span="24" style="padding-top: 35px">
              <span class="guideTextModal">{{
                $t("members.A_unique_team_name")
              }}</span>
            </el-col>
            <el-col :span="24" style="padding-top: 75px">
              <span class="guideTextModal">{{
                $t("members.A_parent_team_and")
              }}</span>
            </el-col>
            <el-col :span="24" style="padding-top: 185px">
              <span class="guideTextModal">{{
                $t("members.Select_a_color_tag")
              }}</span>
            </el-col>
          </div>
          <div v-else class="px-40" style="padding-top: 60px">
            <span class="fc-000000 fs-20 fw-900"
              >{{ modalForm.sup ? modalForm.sup.length : 0 }}
              {{ $t("members.members") }}</span
            >
            <div style="">
              <el-table
                :data="modalForm.sup"
                style="width: 100%"
                :empty-text="$t('members.No_team_members')"
                max-height="760px"
                class="el-table-thin-scrollbar"
              >
                <el-table-column width="58">
                  <template slot-scope="scope">
                    <div class="divMember">
                      <div v-if="scope.row.pic">
                        <img
                          v-lazy="scope.row.pic"
                          :key="scope.row.pic"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                          class="image-skeleton image-profile-42"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                      </div>
                      <div v-else class="image image-profile-42"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: scope.row.firstname,
                              lastName: scope.row.lastname,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('members.Members')" width="180">
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column">
                      <span class="text-name"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ scope.row.firstname }}
                        {{ scope.row.lastname }}</span
                      >
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('members.Team')" width="170">
                  <template slot-scope="scope">
                    <span class="fc4A4A4A fs-14 ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]">{{
                      scope.row.team_name
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('members.Status')"
                  align="center"
                  width="90"
                >
                  <template slot-scope="scope">
                    <div class="div-active">
                      <div
                        class="btn-status"
                        :class="[`status-${scope.row.status}`]"
                      >
                        {{ scope.row.status }}
                      </div>
                      <div class="active">{{ scope.row.to_now }}</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
export default {
  name: "teams",
  created() {
    if (this.updateMember == true) {
      this.$store.dispatch("main/getuser", true).then(() => {
        this.$store.dispatch("newteam/getOrganization");
        this.$store.dispatch("newteam/getTeams", this.user);
        this.$store.commit("authen/setActiveIndex", "3");
      });
    } else {
      this.$store.dispatch("newteam/getOrganization");
      this.$store.dispatch("newteam/getTeams", this.user);
      this.$store.commit("authen/setActiveIndex", "3");
    }
    this.$root.$on('addTeam', () => this.addTeam());
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["newteam/inputSearch"];
      },
      set(value) {
        this.$store.commit("newteam/setinputSearch", { value });
      },
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    teams() {
      return this.$store.getters["newteam/teams"];
    },
    teamsall() {
      return this.$store.getters["newteam/teamsall"];
    },
    page() {
      return this.$store.getters["newteam/page"];
    },
    results() {
      return this.$store.getters["newteam/results"];
    },
    teamDuplicate() {
      return this.$store.getters["newteam/teamDuplicate"];
    },
    loadingTeamsTable() {
      return this.$store.getters["newteam/loadingTeamsTable"];
    },
    teamId() {
      return this.$store.getters["newteam/teamId"];
    },
    teamRandomNumber() {
      return this.$store.getters["newteam/teamRandomNumber"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("newteam/searchTeams", this.inputSearch);
    },
    teamRandomNumber(){
      if(this.teamRandomNumber){
        this.modalForm.internal_id = this.teamRandomNumber
      }
    }
  },
  data() {
    return {
      formLabelWidth: "140px",
      dialogFormVisible: false,
      activeIndex: "1",
      id: "",
      mode: "",
      team: "",
      team_name: "",
      dispteam_parent: "",
      current_page: 1,
      modalForm: {
        id: "",
        mode: "",
        team_name: "",
        dispteam_parent: "",
        parent_pic: "",
        sup: [],
        boss_name: "",
        color: "#6C30CC",
        selectedColorForUpdate: 0,
        checkparent: false,
        internal_id: "",
        multiple: false,
      },
      tagColorMaster: [
        "6C30CC",
        "4F86C6",
        "50B0C6",
        "379392",
        "68D5B5",
        "EE7885",
        "C99EC4",
        "84B1ED",
        "31AADE",
        "F0DC05",
        "E63A40",
      ],
    };
  },
  methods: {
    copyURL(value) {
      const clipboardData = window.clipboardData || navigator.clipboard;

      try {
        clipboardData.writeText(value);
        // Show a success message
        this.$message({
          message: `Copy ID to clipboard.`,
          type: "success",
        });
      } catch (error) {
        // Handle any errors
        console.error("Error copying ID to clipboard:", error);

        // Show an error message
        this.$message({
          message: `Failed to copy ID to clipboard.`,
          type: "error",
        });
      }
    },
    saveTeam() {
      if (!this.modalForm.team_name.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Valid Team Name required.",
          type: "error",
        });
        return false;
      }
      if (this.modalForm.mode == "edit") {
        this.$store.dispatch("newteam/updateTeam", this.modalForm).then(() => {
          const modalForm = this.modalForm;
          let editTeamData = _.find(this.teams, function (o) {
            return o.key === modalForm.id;
          });
          let duplicate = _.find(this.teams, function (o) {
            return o.name === modalForm.team_name;
          });
          if (editTeamData) {
            editTeamData.name = modalForm.team_name;
            editTeamData.color = modalForm.color ? modalForm.color : "";
            editTeamData.updated = format(new Date(), "YYYY-MM-DD HH:mm");
            editTeamData.value = modalForm.team_name;
            if (duplicate) {
              editTeamData.duplicate = true;
              editTeamData.duporder = 1;
            }
          }
          let teamData = _.filter(this.teams, function (o) {
            return o.name === modalForm.team_name && o.key !== modalForm.id;
          });
          let _teamData = _.filter(this.teams, function (o) {
            return o.duplicate;
          });
          let team_duplicate = [];
          team_duplicate["status"] = false;
          team_duplicate["count"] = 0;
          if (teamData.length > 0) {
            team_duplicate["status"] = true;
            team_duplicate["count"] = teamData.length + 1;
            teamData.map((v, index) => {
              v.duplicate = true;
              v.duporder = index + 2;
            });
          } else {
            _teamData.map((v, index) => {
              delete v.duplicate;
              delete v.duporder;
            });
          }
          const _team = _.sortBy(this.teams, [
            function (o) {
              return o.duporder;
            },
            function (o) {
              return o.name;
            },
          ]);
          this.$store.commit("newteam/setResults", _team.length);
          this.$store.commit("newteam/setTeamDuplicate", team_duplicate);
          this.$store.commit("newteam/setTeams", _team.slice(0, 10));
          this.$store.commit("newteam/setTeamsAll", _team);
          this.update_success();
        });
      } else {
        this.$store.dispatch("newteam/createTeam", this.modalForm).then(() => {
          const modalForm = this.modalForm;
          const data = {
            boss_firstname: "",
            boss_lastname: "",
            color: modalForm.color ? modalForm.color : "",
            company: this.user.company,
            key: this.teamId,
            name: modalForm.team_name,
            parent: "",
            parent_color: "",
            parent_name: "",
            pic: "",
            sup: [],
            updated: format(new Date(), "YYYY-MM-DD HH:mm"),
            value: modalForm.team_name,
            internal_id: modalForm.internal_id,
          };

          let teamData = _.filter(this.teams, function (o) {
            return o.name === modalForm.team_name;
          });
          let team_duplicate = [];
          if (teamData.length > 0) {
            data.duplicate = true;
            data.duporder = teamData.length + 1;
            team_duplicate["status"] = true;
            team_duplicate["count"] = teamData.length + 1;
            teamData.map((v, index) => {
              v.duplicate = true;
              v.duporder = index;
            });
          }
          this.teams.push(data);

          const _team = _.sortBy(this.teams, [
            function (o) {
              return o.duporder;
            },
            function (o) {
              return o.name;
            },
          ]);
          this.$store.commit("newteam/setResults", _team.length);
          this.$store.commit("newteam/setTeamDuplicate", team_duplicate);
          this.$store.commit("newteam/setTeams", _team.slice(0, 10));
          this.$store.commit("newteam/setTeamsAll", _team);
          this.update_success();
        });
      }
    },
    addTeam() {
      this.cancelAdd();
      this.$store.dispatch("newteam/generateTeamRandomNumber");
      this.dialogFormVisible = true;
    },
    editTeam(item) {
      let checkParent = _.filter(this.teamsall, { parent: item.key });
      if (checkParent.length > 0) {
        this.modalForm.checkparent = true;
      } else {
        this.modalForm.checkparent = false;
      }
      this.modalForm.mode = "edit";
      this.modalForm.id = item.key;
      this.modalForm.team_name = item.name;
      this.modalForm.dispteam_parent = item.parent_name;
      this.modalForm.parent_pic = item.pic;
      this.modalForm.sup = item.sup;
      if (item.boss_firstname) {
        this.modalForm.boss_name =
          item.boss_firstname + " " + item.boss_lastname;
      } else {
        this.modalForm.boss_name = "";
      }

      this.modalForm.color = item.color;
      this.modalForm.parent_color = item.parent_color;
      let colorCode = null;
      if (item.color) {
        colorCode = item.color.replace(/#/g, "");
      }
      this.modalForm.selectedColorForUpdate =
        this.tagColorMaster.indexOf(colorCode);
      this.modalForm.internal_id = item.internal_id;
      this.modalForm.multiple = (item.multiple) ? item.multiple : false;
      this.dialogFormVisible = true;
    },
    cancelAdd() {
      this.modalForm.mode = "";
      this.modalForm.id = "";
      this.modalForm.team_name = "";
      this.modalForm.dispteam_parent = "";
      this.modalForm.parent_pic = "";
      this.modalForm.sup = [];
      this.modalForm.boss_name = "";
      this.modalForm.color = "#6C30CC";
      this.modalForm.selectedColorForUpdate = 0;
      this.modalForm.checkparent = false;
      this.modalForm.internal_id = "";
      this.modalForm.multiple = false;
      // this.team_name = ''
      // this.team = ''
      // this.mode = ''
      // this.id = ''
      // this.dispteam_parent = ''
      this.dialogFormVisible = false;
    },
    update_success() {
      let message = "Create success";
      if (this.modalForm.mode == "edit") {
        message = "Team Info Updated";
      }
      this.cancelAdd();
      this.$message({
        type: "success",
        message,
      });
      this.$store.dispatch("newmember/getTeamAll", this.user);
      this.$store.dispatch("newmember/getMember", this.user);
      this.$store.dispatch("membermanager/getMemberManager", this.user);
    },
    deleteTeam() {
      this.$confirm(
        `Are you sure to delete <strong>${this.modalForm.team_name}</strong>?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Sure",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.$store.dispatch("newteam/deleteTeam", this.modalForm.id);
          this.dialogFormVisible = false;
          this.$message({
            type: "success",
            message: "Delete completed",
          });
        })
        .then(() => {
          this.$store.dispatch("newmember/getTeamAll", this.user);
          this.$store.dispatch("newmember/getMember", this.user);
          this.$store.dispatch("membermanager/getMemberManager", this.user);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    handleSelectTeam(item) {
      this.team = item.key;
    },
    querySearchTeam(queryString, cb) {
      //var links = this.links;
      var links = this.teamsall;
      var results = queryString
        ? links.filter(this.createFilterTeam(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilterTeam(queryString) {
      return (link) => {
        return link.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.$store.dispatch("newteam/currentChange", val);
    },
    sortBy(type) {
      if (type == "name") {
        document.getElementById("sortby").innerHTML = "Sort by Name";
      } else if (type == "parent") {
        document.getElementById("sortby").innerHTML = "Sort by Parent";
      }
      this.$store.dispatch("newteam/sortBy", type);
    },
    tableRowStyle({ row, rowIndex }) {
      if (row.duplicate) {
        return "background: #FEEAE9;";
      }
    },
    teamBarStyleFunc(color) {
      if (color) {
        return "background: " + color;
      } else {
        return "background:#747474;";
      }
    },
    tagColorCheckFunc(index, color) {
      this.modalForm.selectedColorForUpdate = index;
      this.modalForm.color = "#" + color;
    },
    renderSidebarColorFunc(code) {
      if (code) {
        let color = code.replace(/#/g, "");
        return `bg-${color}`;
      } else {
        return "bg-747474";
      }
    },
    renderParentSidebarColorFunc(code) {
      if (code) {
        let color = code.replace(/#/g, "");
        return `border-left-color-${color}`;
      } else {
        return `border-left-color-`;
      }
    },
    renderMemberPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
  },
};
</script>

<style scoped>
.grid-4 {
  display: grid;
  grid-template-columns: 7px 25% 25% 25% 25%;
  margin-top: 12px;
  height: 79px;
  border: 1px solid #e0e0e0;
  border-radius: 2px;
}
.txtIncomplete {
  font-size: 14px;
  color: #f44336;
  margin-left: 16px;
  text-decoration: underline;
}
.btnAddTeam {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
}
.btnAddTeam:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.divContent {
  background: #ffffff;
}
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}
.el-submenu {
  width: 220px;
}
.txtSubOption {
  font-size: 14px;
  width: 220px;
}
.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}
.el-dropdown-menu__item {
  font-size: 14px;
  font-weight: 500;
  color: #585858;
}
li.el-dropdown-menu__item:hover {
  background-color: #6c30cc;
  color: #ffffff;
}
div.el-dropdown {
  padding-left: 0px;
}
.image-profile-32 {
  border: 1px solid #ffffff;
}
.duplicateStyle {
  background: #feeae9;
}
.team-sitebar {
  border-radius: 2px 0px 0px 2px;
  opacity: 1;
  height: calc(100% + 2px);
  margin: -1px;
}
.first-column {
  background-color: #f8f8f8;
  height: 847px;
  border-radius: 3px 0 0 3px;
}
.second-column {
  height: 847px;
}
.txtHeaderStyle {
  margin: 0px;
  padding-bottom: 8px;
  font-size: 16px;
  font-weight: 700;
  color: #2d2e36;
}
.tagColor {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 8px;
}
.bg- {
  background: #747474;
}
.active-check {
  background-image: url("../../assets/images/outline-check-18px@2x.png");
  background-repeat: no-repeat;
  background-size: 30px 30px;
}
.btnAddTeamModal {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnAddTeamModal:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.btnCancelTeamModal {
  width: 122px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.guideTextModal {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  opacity: 0.65;
  word-break: normal;
}
.sidebar-modal-color {
  content: "";
  position: absolute;
  border-radius: 2px 0 0 2px;
  height: 100%;
  top: 0;
  left: 0;
  width: 14px;
}
.btn-cancel-color {
  background-color: #747474;
}
.style-internal-value {
  height: 46px;
  background-color: #e4e4e4;
  font-size: 18px;
  color: #000000e6;
  padding: 0 32px;
}
</style>
<style lang="scss">
#tabTeams .el-submenu__title {
  height: 40px;
  line-height: 40px;
  border-radius: 4px 0 0 4px;
  background-color: #f4f4f4;
}
#tabTeams .el-table__header-wrapper {
  padding-top: 12px;
}
#tabTeams .el-table .cell {
  line-height: 17px;
}
#tabTeams .el-table th > .cell {
  font-weight: 700;
}
#tabTeams .el-table td {
  padding: 9px 0px;
}
#tabTeams span.el-checkbox__inner::after {
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 6px;
  width: 6px;
  height: 13px;
}
#tabTeams label.el-checkbox {
  line-height: 24px;
}
#tabTeams .el-checkbox__input {
  zoom: 1 !important;
}
#tabTeams .el-dialog {
  border-radius: 3px;
  width: 1100px;
}
#tabTeams .el-dialog__header {
  padding: 0px;
}
#tabTeams .el-dialog__body {
  padding: 0px;
  height: 847px;
  border-radius: 3px;
}
#tabTeams .profileform .team-field .el-input__inner {
  height: 46px;
  font-size: 18px;
  font-weight: 400;
}
#tabTeams .el-input.is-disabled.disable .el-input__inner {
  background-color: #e4e4e4;
  border-color: #e4e4e4;
}
#tabTeams .profileform .team-parent-field .el-input__inner {
  height: 60px;
  background: #e4e4e4;
  border-left-width: 7px;
  border-left-style: solid;
  padding: 0 32px;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  opacity: 0.9;
}
#tabTeams .profileform .team-parent-field input::placeholder {
  color: #000000;
  opacity: 0.9;
}
#tabTeams .profileform .border-left-color- .el-input__inner {
  border-left-color: #747474;
}
#tabTeams .profileform .border-left-color-6C30CC .el-input__inner {
  border-left-color: #6c30cc;
}
#tabTeams .profileform .border-left-color-4F86C6 .el-input__inner {
  border-left-color: #4f86c6;
}
#tabTeams .profileform .border-left-color-50B0C6 .el-input__inner {
  border-left-color: #50b0c6;
}
#tabTeams .profileform .border-left-color-379392 .el-input__inner {
  border-left-color: #379392;
}
#tabTeams .profileform .border-left-color-68D5B5 .el-input__inner {
  border-left-color: #68d5b5;
}
#tabTeams .profileform .border-left-color-EE7885 .el-input__inner {
  border-left-color: #ee7885;
}
#tabTeams .profileform .border-left-color-C99EC4 .el-input__inner {
  border-left-color: #c99ec4;
}
#tabTeams .profileform .border-left-color-84B1ED .el-input__inner {
  border-left-color: #84b1ed;
}
#tabTeams .profileform .border-left-color-31AADE .el-input__inner {
  border-left-color: #31aade;
}
#tabTeams .profileform .border-left-color-F0DC05 .el-input__inner {
  border-left-color: #f0dc05;
}
#tabTeams .profileform .border-left-color-E63A40 .el-input__inner {
  border-left-color: #e63a40;
}
</style>
